/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import Button from "../../button";

// Interface for Page Not Found Props
interface PageNotFoundProps {
  history?: any;
  t?: any;
}
// Interface for PageNotFound State
interface PageNotFoundState {}

/**
 * Page Not Found Screen component
 *
 * @namespace PageNotFound
 */
class PageNotFound extends React.Component<
  PageNotFoundProps,
  PageNotFoundState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }
  
  /**
   * This method is used for handle button click
   *
   *
   */
  handleError = () => {
    this.props.history.push("/home");
  };

  render() {
    return (
      <>
        <div className={"error-screen-container align-middle"}>
          <div className="error-screen-wrapper">
            <div className="error-middle-area">
              <div className="title">{this.props.t("error.page_doesnt_exist")}</div>
              <Button
                onButtonClick={() => this.handleError()}
                name={this.props.t("error.got_to_home_page")}
                className={"app-btn border-btn"}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PageNotFound;
